var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Glyph / Close / Grey Copy 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Pets-/-Modal-/-Edit-Figo-Tag-/-Step-1",
    transform: "translate(-382.000000, -16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "X",
    transform: "translate(382.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Circle",
    fill: "#B0BBBF",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,5.25 C12.4142136,5.25 12.75,5.58578644 12.75,6 L12.75,11.25 L18,11.25 C18.4142136,11.25 18.75,11.5857864 18.75,12 C18.75,12.4142136 18.4142136,12.75 18,12.75 L12.75,12.75 L12.75,18 C12.75,18.4142136 12.4142136,18.75 12,18.75 C11.5857864,18.75 11.25,18.4142136 11.25,18 L11.25,12.75 L6,12.75 C5.58578644,12.75 5.25,12.4142136 5.25,12 C5.25,11.5857864 5.58578644,11.25 6,11.25 L11.25,11.25 L11.25,6 C11.25,5.58578644 11.5857864,5.25 12,5.25 Z",
    fill: "#FFFFFF",
    transform: "translate(12.000000, 12.000000) rotate(45.000000) translate(-12.000000, -12.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.51ebba938e5db97cf8cb88be694610e8.svg";
export { ForwardRef as ReactComponent };